import { AlertTriangle, RefreshCw } from "lucide-react";
import styled from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/ko";

import { HelpIcon } from "assets/icons/system";
import { ChartIcon } from "assets/icons/businessDashboard";

dayjs.locale("ko");

const SectionWrapper = styled.div`
  padding: 24px;
  background-color: #0f2859;
  position: relative;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
  color: #fff;
  position: relative;
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.4px;
  font-weight: bold;
  color: #fff;
`;

const HelpButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  cursor: pointer;
  background: none;
  border: none;
  transition: color 0.2s;
  &:hover {
    color: #fff;
  }
`;

const SectionTime = styled.p`
  font-size: 12px;
  font-weight: bold;
  line-height: 14px;
  letter-spacing: -0.2px;
  color: #949db2;
  margin: 0;
`;

const ErrorBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 1rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
  z-index: 10;
  position: relative;
`;

const ErrorIconBox = styled.div`
  width: 36px;
  height: 36px;
  background: #fee2e2;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
`;

const ErrorTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 4px;
`;

const ErrorDesc = styled.p`
  color: #6b7280;
  margin-bottom: 12px;
  font-size: 13px;
  text-align: center;
`;

const RetryButton = styled.button`
  background: #dc2626;
  &:hover {
    background: #b91c1c;
  }
  color: #fff;
  border-radius: 14px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
  border: none;
`;

const RetryIcon = styled(RefreshCw)`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;

export const RealtimeSalesSectionError = ({
  onRetry,
}: {
  onRetry?: () => void;
}) => {
  const handleRefresh = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  return (
    <SectionWrapper>
      <SectionHeader>
        <ChartIcon />
        <HeaderContent>
          <SectionTitle>실시간 매출</SectionTitle>
          <HelpButton type="button">
            <HelpIcon />
          </HelpButton>
          <SectionTime>오늘 {dayjs().format("HH:mm")} 기준</SectionTime>
        </HeaderContent>
      </SectionHeader>
      <ErrorBox>
        <ErrorIconBox>
          <AlertTriangle
            width={18}
            height={18}
            color="#dc2626"
            strokeWidth={2}
          />
        </ErrorIconBox>
        <ErrorTitle>데이터를 불러올 수 없습니다</ErrorTitle>
        <ErrorDesc>
          실시간 매출 데이터를 불러오는 중 예상치 못한 오류가 발생했습니다.
        </ErrorDesc>
        <RetryButton onClick={handleRefresh}>
          <RetryIcon />
          다시 시도
        </RetryButton>
      </ErrorBox>
    </SectionWrapper>
  );
};
